export enum PermissionType {
  ANNUAL = 'ANNUAL',           // Yıllık izin
  SICK = 'SICK',              // Hastalık izni
  MATERNITY = 'MATERNITY',    // Doğum izni
  PATERNITY = 'PATERNITY',    // Babalık izni
  MARRIAGE = 'MARRIAGE',      // Evlilik izni
  BEREAVEMENT = 'BEREAVEMENT',// Ölüm izni
  UNPAID = 'UNPAID',          // Ücretsiz izin
  OTHER = 'OTHER'             // Diğer
} 